/*
 * @Author: your name
 * @Date: 2021-11-09 17:07:52
 * @LastEditTime: 2021-11-09 17:18:41
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: \prisme:\tutu\tutu-admin\src\api\production\production.ts
 */
import request from '@/utils/request'
import qs from 'qs'

// 获取桌面版兔兔版本列表
export function getDesktopVersionList(params: any) {
  return request({
    url: '/releaseManagement/tutuDesktopVersionList',
    method: 'get',
    params
  })
}

// 桌面版兔兔版本详情信息接口
export function getDesktopVersionDetail(params: any) {
  return request({
    url: '/releaseManagement/getTutuDeskTopVersion',
    method: 'get',
    params
  })
}

export const saveTutuDesktopVersion = (data: any) =>
  request({
    url: '/releaseManagement/saveTutuDesktopVersion',
    method: 'post',
    data: qs.stringify(data)
  })
